<template>
  <div style="height: 100%;">
    <el-row type="flex" justify="end" align="middle" style="height: 40px; margin-bottom: 8px;">
      <el-row tyle="flex" class="title-h4 mr-r10">
        서비스 맵 선택
      </el-row>
      <el-select v-model="targetMapId" size="small" @change="onChangeMapId">
        <el-option v-for="item in mapInfoList" :key="item.treeKey" :label="item.label" :value="item.mapId"></el-option>
      </el-select>
    </el-row>
    <div style="width: 100%; height: calc(100% - 48px); position: relative; border: solid 1px #ddd;">
      <w-topologymap-panel v-if="activeFlag" ref="topologymapPanel" style="height: calc(100% - 1px);" :options="options"></w-topologymap-panel>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WTopologymapPanel from '@/views/topologymap/layout/TopologymapPanel';
import { MapPopup } from '@/views/topologymap/js/maps';
import ServiceApi from '@/api/performance/service/service';

export default {
  name: 'WServiceMap',
  components: {
    WTopologymapPanel,
  },
  props: {
    active: {
      type: Boolean,
    },
  },
  data() {
    return {
      targetMapId: null,
      activeFlag: false,
      topologymapPanel: null,
      mapInfoList: [],
      options: {
        mapId: 0,
        fit: true,
        toolbar: false, // 상단 툴바 제공
        action: true, // 마우스관련 액션
      },
    };
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  created() {
    this.$nextTick(() => {
      if (this.active) {
        window.addEventListener('resize', this.onWindowResize);
      }
    });
  },
  beforeDestroy() {
    this.$nextTick(() => {
      if (this.active) {
        window.removeEventListener('resize', this.onWindowResize);
        MapPopup.closeAndHideAll(true);
      }
    });
  },
  watch: {
    active: {
      handler(value) {
        if (value) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    onWindowResize() {
      this.onWidgetResize();
    },
    loadData() {
      if (!this.active) {
        return;
      }
      this.activeFlag = false; // init
      this.targetMapId = null;
      this.loadMapInfoList();
    },
    loadSampleData() {
      this.topologymapPanel = null;
    },
    onWidgetResize() {
      try {
        this.$nextTick(() => {
          this.$refs.topologymapPanel.getGraph().updateViewport();
          this.$refs.topologymapPanel.getGraph().zoomToOverview();
        });
      } catch (e) {
        // ignore
      }
    },
    loadMapInfoList() {
      ServiceApi.getServiceMapInfoList({ objId: this.selectedNode.obj.objId }).then((res) => {
        if (res.data.success) {
          this.mapInfoList = res.data.data;
        }
        if (res.data.data.length > 0) {
          this.targetMapId = res.data.data[0].mapId;
          this.options.mapId = res.data.data[0].mapId;
          this.activeFlag = true;
        }
      });
    },
    onChangeMapId(value) {
      this.options.mapId = value;
      const topologymapPanel = this.$refs.topologymapPanel;
      topologymapPanel.refreshMap();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/operation/service/components/ServiceMap.vue